import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";
import Link from "next/link";
import { useInterval } from "@hooks/index";
import styles from "./redirect.module.css";

export function Redirect({ type, to, label }) {
  const router = useRouter();
  const [timer, setTimer] = useState(5);

  useInterval(() => {
    if (timer > 0) {
      setTimer(timer - 1);
    }
  }, 1000);

  useEffect(() => {
    if (timer === 0) {
      router.push(to);
    }
  }, [timer]);

  return (
    <section className={styles.container}>
      <div className={styles.inner}>
        <h1 className={styles.header}>{`Shucks! This ${type} is no longer available.`}</h1>
        <article className={styles.timer}>
          <p>
            {`Sorry for the inconvenience! Redirecting you to `}
            <Link href={to}>
              <a className={styles.link}>{label}</a>
            </Link>
            {` in ${timer} seconds.`}
          </p>
        </article>
      </div>
    </section>
  );
}

Redirect.propTypes = {
  type: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
